import { ComponentSettings, FieldTypes } from "../settings/settings";
import { obsolescencelifeCycleRiskOptions, yesNoOptions } from "./part.settings";

const field = {
  warehouseGroupId: {
    type: FieldTypes.value,
    text: { de: "Warengruppe", en: "Warehouse Group", nl: "Warehouse Group" },
  },
  warehouseGroupDescription: {
    type: FieldTypes.value,
    text: {
      de: "Warengruppe Bezeichnung",
      en: "Warehouse Group Description",
      nl: "Warehouse Group Description",
    },
  },
  obsolescenceManagement: {
    type: FieldTypes.checkbox,
    text: {
      de: "Proaktiv",
      en: "Proactive",
      nl: "Proactive",
    },
    options: yesNoOptions,
    checkboxLabels: yesNoOptions,
  },
  warehouseImpact: {
    type: FieldTypes.options,
    text: {
      de: "Warengruppe Auswirkung",
      en: "Warehouse Impact",
      nl: "Warehouse Impact",
    },
    options: obsolescencelifeCycleRiskOptions,
  },
  create_time: {
    type: FieldTypes.timestamp,
    text: {
      de: "Erstellt am",
      en: "Created on",
      nl: "Gemaakt op",
    },
  },
  update_time: {
    type: FieldTypes.timestamp,
    text: {
      de: "Aktualisiert am",
      en: "Updated on",
      nl: "Bijgewerkt op",
    },
    search: false,
  },
};

const settings = {
  permission: {},
  text: {
    invalidValues: {
      de: "Die eingegebenen Werte entsprechen nicht dem gültigen Format.\nBitte stellen Sie sicher, dass Proaktiv entweder 'true' oder 'false' ist und Warengruppe Auswirkung einer der folgenden Werte ist: 'low', 'medium', 'high' oder leer.",
      en: "The entered values are not in the correct format.\nPlease ensure that Proactive is either 'true' or 'false' and Warehouse Impact is one of the following: 'low', 'medium', 'high', or blank.",
      nl: "The entered values are not in the correct format.\nPlease ensure that Proactive is either 'true' or 'false' and Warehouse Impact is one of the following: 'low', 'medium', 'high', or blank.",
    },
    save: {
      de: "Änderungen übernehmen",
      en: "Save Changes",
      nl: "Bewaar de wijzigingen",
    },
    discard: {
      de: "Änderungen verwerfen",
      en: "Discard changes",
      nl: "Wijzigingen negeren",
    },
    close: { de: "Schließen", en: "Close", nl: "Sluit" },
    modalTitle: {
      de: "Bestätigung",
      en: "Confirm",
      nl: "Bevestigen",
    },
    actions: {
      de: "Aktionen",
      en: "Actions",
      nl: "Acties",
    },
  },
  url: {},
  field,
  list: {},
  additionalInfo: {},
};

export const warehouseGroup: ComponentSettings<typeof settings> = settings;
